import React from "react";
import { Link } from 'react-router-dom';
import { Add as AddIcon } from '@mui/icons-material';
import { Button } from "react-admin";
import { Box, Typography, Stack, useTheme } from "@mui/material";

const ReportHeader = ({ title, description, type, canSeeActionButtons }) => {
  const theme = useTheme();
  
  // Fallback colors if theme is not available
  const primaryColor = theme?.palette?.primary?.main || '#1976d2';
  const primaryDark = theme?.palette?.primary?.dark || '#1565c0';
  const secondaryColor = theme?.palette?.secondary?.main || '#dc004e';
  
  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4 }}>
        <Box>
          <Typography
            variant="h4"
            fontWeight="800"
            sx={{
              background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
            }}
          >
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            {description}
          </Typography>
        </Box>

        {canSeeActionButtons && (
          <Stack direction="row" spacing={2}>
            <Button
              component={Link}
              to="/in-kind-offers/create"
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              sx={{
                background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryDark} 100%)`,
                '&:hover': {
                  background: `linear-gradient(135deg, ${primaryDark} 0%, ${primaryColor} 100%)`,
                }
              }}
            >
              Create In-Kind {type === 'services' ? 'Service' : 'Offer'}
            </Button>
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default ReportHeader;